import { ResourceCategoryAvailability, WithAvailabilityBlockId } from '@mews-commander/types';
import { ResolveRoute } from '@mews/routing';
import { RouteName } from '@mews-commander/enums';
import { sumBy } from '@mews/fp';
import { FORM_NAME } from './constants';

export const getFormNameUtil = (id: string) => `${FORM_NAME}-${id}`;

export const getAvailabilityBlockActionLogUrl =
    (resolveRoute: ResolveRoute<WithAvailabilityBlockId>) =>
    ({ availabilityBlockId }: WithAvailabilityBlockId) =>
        resolveRoute(RouteName.AvailabilityBlockActionLog, { availabilityBlockId });

export const getResourceCategoryBlockAdjustments = ({
    categoryAvailabilities,
    dateTimeUtc,
    availabilityBlockId,
}: {
    categoryAvailabilities: Array<ResourceCategoryAvailability> | undefined;
    dateTimeUtc: string;
    availabilityBlockId: string;
}) => {
    const timeUnitAvailabilities = categoryAvailabilities?.find(
        ({ timeUnitBaseStartUtc }) => timeUnitBaseStartUtc === dateTimeUtc
    );
    const blockAdjustments = timeUnitAvailabilities?.blockAdjustmentData?.filter(
        (data) => data.availabilityBlockId === availabilityBlockId
    );

    return blockAdjustments ?? [];
};

export const getResourceCategoryBlockAdjustmentValue = ({
    categoryAvailabilities,
    dateTimeUtc,
    availabilityBlockId,
}: {
    categoryAvailabilities: Array<ResourceCategoryAvailability>;
    dateTimeUtc: string;
    availabilityBlockId: string;
}) => {
    const adjustments = getResourceCategoryBlockAdjustments({
        categoryAvailabilities,
        dateTimeUtc,
        availabilityBlockId,
    });

    return sumBy(({ blockAvailability }) => blockAvailability, adjustments);
};
